<template>
    <DCard
        :title="__('orders.show.customer_details')"
        :title-middle="__('orders.show.current_customer_details')"
        :main-title-has-slot="true"
        padding
    >
        <template #titleHasSlot>
            <DSwitch
                color="success"
                variant="3d"
                :disabled="isInLoadingState"
                :checked="showSection"
                @update:checked="showCardSection"
            />
        </template>
        <DRow v-if="showSection">
            <DCol col="6">
                <DFormRow :label="__('orders.show.customer')">
                    {{ order.customerFirstname }} {{ order.customerLastname }}
                </DFormRow>
                <DFormRow :label="__('orders.show.customer_id')">
                    {{ order.rawContents?.customer_id ?? '' }}
                </DFormRow>
                <DFormRow :label="__('orders.show.customer_type')">
                    <span v-if="order.customerType !== null">{{ __('orders.show.' + order.customerType) }}</span>
                </DFormRow>
                <DFormRow :label="__('orders.show.company')">
                    {{ order.customerCompany }}
                </DFormRow>
                <DFormRow :label="__('orders.show.brand')">
                    {{ order.customerBrand }}
                </DFormRow>
                <DFormRow :label="__('orders.show.address')">
                    {{ order.customerAddress1 }}<br>
                    {{ order.customerPostalCode }} {{ order.customerCity }}<br>
                    {{ order.customerCountryName }}
                </DFormRow>
                <DFormRow :label="__('orders.show.phone_number')">
                    {{ order.customerPhoneNumber }}
                </DFormRow>
                <DFormRow :label="__('orders.show.email')">
                    {{ order.customerEmail }}
                </DFormRow>
            </DCol>
            <DCol col="6">
                <div class="customer-data">
                    <Link
                        v-if="order.databaseCustomerId !== null"
                        :href="customerRoute()"
                        target="_blank"
                    >
                        {{ getCustomerName() }}
                    </Link>
                    <span v-else>
                        {{ getCustomerName() }}
                    </span>
                </div>
                <div class="customer-data">
                    <span v-if="order.databaseCustomerType !== null">{{ order.databaseCustomerId }}</span>
                </div>
                <div class="customer-data">
                    <span v-if="order.databaseCustomerType !== null">{{ __('orders.show.' + order.databaseCustomerType) }}</span>
                </div>
                <div class="customer-data">
                    {{ order.databaseCustomerCompany }}
                </div>
                <div class="customer-data">
                    {{ order.databaseCustomerBrand }}
                </div>
                <div class="customer-data-address">
                    {{ order.databaseCustomerAddress1 }}<br>
                    {{ order.databaseCustomerPostalCode }} {{ order.databaseCustomerCity }}<br>
                    {{ order.databaseCustomerCountryCode }}
                </div>
                <div class="customer-data">
                    {{ order.databaseCustomerPhoneNumber }}
                </div>
                <div class="customer-data">
                    {{ order.databaseCustomerEmail }}
                </div>
                <div v-if="showRemoveAssignmentButton">
                    <DButton
                        color="danger"
                        mini
                        :label="__('orders.show.remove_customer_assignment')"
                        @click="$emit('unassign-customer', order)"
                    />
                </div>
            </DCol>
        </DRow>
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { ref, computed } from 'vue'

const props = defineProps({
    order: {
        type: Object,
        default () {
            return {}
        }
    },
    section: {
        type: String,
        default () {
            return ''
        }
    },
    showSection: {
        type: Boolean,
        default () {
            return true
        }
    },
    userListView: {
        type: Array,
        default: () => {
            return []
        }
    }
})
function getCustomerName () {
    if (props.order.databaseCustomerFirstname === null) {
        if (props.order.client === 'PSA' && props.order.databaseCustomerId !== null) {
            return props.order.databaseCustomerId
        }

        return ''
    }

    if (props.order.databaseCustomerCompany !== null) return `${props.order.databaseCustomerFirstname} ${props.order.databaseCustomerLastname} (${props.order.databaseCustomerCompany})`

    return `${props.order.databaseCustomerFirstname} ${props.order.databaseCustomerLastname}`
}

function customerRoute () {
    return props.order.databaseCustomerId !== null ? route('customers.customers.show', { customer: props.order.databaseCustomerId }) : '#'
}

const emit = defineEmits(['update-list', 'unassign-customer'])

const showRemoveAssignmentButton = computed(() => {
    return props.order.status === 'screening' &&
        props.order.databaseCustomerId !== null &&
        props.order.client === 'PSA'
})

const columns = ref(props.userListView)

const form = useForm({
    columns: props.userListView
})

function showCardSection (value) {
    for (const column of columns.value) {
        if (column.column === props.section) {
            column.show_column = value
        }
    }

    form.columns = flattenColumns(columns.value)

    form.post(route('settings.list-view-settings.store'))

    emit('update-list', columns.value)
}

function flattenColumns (columns) {
    if (columns.length === 0) {
        return {}
    }

    const result = {}

    for (const [key, column] of Object.entries(columns)) {
        result[key] = JSON.parse(JSON.stringify(column))
    }

    return result
}
</script>

<style lang="scss" scoped>
.customer-data {
    padding: 10px 0;
    min-height: 34px;

    &:not(:last-child) {
        margin-bottom: 25px;
    }
}
.customer-data-address {
    padding: 0;
    min-height: 34px;
    margin-bottom: 25px;
}
</style>
